// extracted by mini-css-extract-plugin
export var centerText = "_8p-8";
export var container = "_8p-0";
export var doughnutContainer = "_8p-7";
export var legend = "_8p-a";
export var legendItemColorDisplay = "_8p-b";
export var legendItemLabel = "_8p-d";
export var legendItemValue = "_8p-c";
export var lg = "_8p-5";
export var maxWidth = "_8p-9";
export var md = "_8p-4";
export var responsive = "_8p-6";
export var sm = "_8p-3";
export var xs = "_8p-2";
export var xxs = "_8p-1";